/**
 * Formatters partagés (montants, dates) — locale fr-FR.
 * Centralisés pour garantir une présentation cohérente dans toute l'app.
 */

const fallbackCurrencyFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
});

const dateFormatter = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium' });

/** Formate un montant dans la devise fournie (repli EUR si code invalide). */
export function formatAmount(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(amount);
  } catch {
    return fallbackCurrencyFormatter.format(amount);
  }
}

/** Formate une date ISO (yyyy-MM-dd) en date lisible. */
export function formatDate(isoDate: string): string {
  const date = new Date(`${isoDate}T00:00:00`);
  return Number.isNaN(date.getTime()) ? isoDate : dateFormatter.format(date);
}

/** Formate un niveau de confiance (0–1) en pourcentage. */
export function formatConfidence(confidence: number): string {
  return `${Math.round(confidence * 100)} %`;
}
